/**
 * Teller voor de 5-minuten-antwoordklok (18-10-2026, Jordy): een band over de
 * volle breedte op Chats, direct onder de "open chats"-balk en boven de Live
 * Feed (eerst een zwevend bolletje rechtsboven). "2 answering · 0:48", in de
 * kleur van het meest urgente gesprek; pulserend onder 1:00. Klik = naar dat
 * gesprek. Alleen als er bij mij een klok loopt (anders neemt hij geen ruimte
 * in); tikt dan één keer per seconde (alleen deze band).
 */
import { useEffect, useState, useSyncExternalStore } from 'react'
import { useInRouterContext, useNavigate } from 'react-router-dom'
import { abonneer, klokFase, klokRijen, mijnKlokken, restSeconden } from '../lib/claimKlok'

export function KlokTeller() {
  // Buiten een router (bv. een losse render in een test) is er niets te tonen.
  return useInRouterContext() ? <KlokTellerBinnen /> : null
}

function KlokTellerBinnen() {
  const rijen = useSyncExternalStore(abonneer, klokRijen, klokRijen)
  const navigate = useNavigate()
  const [, tik] = useState(0)
  const lopend = mijnKlokken(rijen)
  useEffect(() => {
    if (!lopend.length) return
    const t = window.setInterval(() => tik((n) => n + 1), 1000)
    return () => window.clearInterval(t)
  }, [lopend.length])
  if (!lopend.length) return null
  const eerste = lopend[0]
  const sec = restSeconden(eerste.inbox_claim_until)
  const fan = eerste.fan_display_name || eerste.fan_username || 'fan'
  return (
    <button type="button" className="klokteller" data-fase={klokFase(sec)} data-testid="klokteller"
            title={`Most urgent: ${fan}. Click to open that chat.`}
            onClick={() => navigate(`/conversations/show/${eerste.id}`)}>
      <span className="stip" aria-hidden="true" />
      <b>{lopend.length} answering · {Math.floor(sec / 60)}:{String(sec % 60).padStart(2, '0')}</b>
      <span className="mut2">most urgent: {fan} — click to open</span>
    </button>
  )
}
